module.exports = __webpack_public_path__ + "img/organized-categories.83c205eb.png";